import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route';
import { DatabaseContainerLoader } from '@confluence/confluence-databases/entry-points/DatabaseContainerLoader';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { fg } from '@confluence/feature-gating';

import SpaceRestriction from '../../SpaceBase/SpaceRestriction';
import { LazyDwellTime, LazyConsumptionViewedAndCompletedEventTracker } from '../lazyComponents';

export const DatabaseViewRoute = ({ params: { contentId, spaceKey } }: RouteMatch) =>
	fg('confluence-fix-space-db-redirect-behaviour') ? (
		<SpaceRestriction spaceKey={spaceKey} contentId={contentId}>
			<DatabaseContainerLoader contentId={contentId} spaceKey={spaceKey} />
			<LazyDwellTime />
			<LazyConsumptionViewedAndCompletedEventTracker
				spaceKey={spaceKey}
				source="DatabaseViewRoute"
			/>
		</SpaceRestriction>
	) : (
		<SpaceRestriction spaceKey={spaceKey}>
			<DatabaseContainerLoader contentId={contentId} spaceKey={spaceKey} />
			<LazyDwellTime />
			<LazyConsumptionViewedAndCompletedEventTracker
				spaceKey={spaceKey}
				source="DatabaseViewRoute"
			/>
		</SpaceRestriction>
	);

DatabaseViewRoute.NAVIGATION_PARAMS = ({
	name: routeName,
	params: { contentId, spaceKey },
}: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'databaseScreen',
			id: contentId,
			attributes: {
				contentId,
			},
		},
		pageState: {
			contentId,
			spaceKey,
			contentType: 'database',
			routeName,
		},
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
		isViewPage: true,
	},
});
